import type { CSSProperties, FC, ReactNode } from 'react'

import { Check } from 'lucide-react'
import { PHOTO } from '@/constants/media'

const TICKS = [
    'Underlaget er i lodd og plan',
    'Membranen er påført i to strøk',
    'Bilde av sluk og mansjett'
]

const STAMP_TEXT = 'Kontrollert · Dokumentert · Signert · '

/** Georg on site, a short checklist ticking itself off, and a slowly turning approval stamp. */
export const KvalitetHeroVisual: FC = (): ReactNode => (
    <div className='load-fade relative mx-auto w-full max-w-[44rem]' style={{ '--load-delay': '0.45s' } as CSSProperties}>
        <div className='relative aspect-[5/4] overflow-hidden bg-night-raised md:aspect-[4/3]'>
            <img
                src={PHOTO.georgOrangeLevel}
                alt='To håndverkere fra Hh Håndverk med et oransje vater foran et nybygg'
                fetchPriority='high'
                decoding='async'
                className='size-full object-cover object-[50%_35%]'
            />
            <div className='absolute inset-0 bg-gradient-to-tr from-night-deep/70 via-transparent to-transparent' />

            <p className='t-label absolute right-[18%] top-[9.5%] hidden items-center gap-2 bg-paper px-2 py-1 text-night sm:flex' aria-hidden='true'>
                I lodd · 0,0 mm
                <span className='h-px w-6 bg-signal' />
            </p>
        </div>

        <div className='ks-ticks absolute -bottom-10 right-4 w-[min(19rem,78%)] bg-paper p-4 text-night shadow-2xl md:-right-8 md:p-5'>
            <p className='t-label flex items-center justify-between text-slate'>
                Sjekkliste · Bad 2. etg
                <span className='bg-night px-1.5 py-0.5 text-paper'>KS</span>
            </p>
            <ul className='mt-3 flex flex-col gap-2.5'>
                {TICKS.map((tick, i) => (
                    <li key={tick} className='flex items-center gap-3 text-sm font-medium' style={{ '--t': i } as CSSProperties}>
                        <span className='ks-tick flex size-5 shrink-0 items-center justify-center border border-night' aria-hidden='true'>
                            <Check className='size-3.5' strokeWidth={3} />
                        </span>
                        {tick}
                    </li>
                ))}
            </ul>
        </div>

        <div className='ks-stamp absolute -left-3 -top-8 size-28 text-signal md:-left-10 md:-top-12 md:size-36' aria-hidden='true'>
            <svg viewBox='0 0 200 200' className='ks-stamp-ring size-full'>
                <defs>
                    <path id='ks-stamp-path' d='M100 100 m-78 0 a78 78 0 1 1 156 0 a78 78 0 1 1 -156 0' />
                </defs>
                <circle cx='100' cy='100' r='96' fill='#241D2D' />
                <text fill='currentColor' fontSize='15.5' letterSpacing='3.4' fontFamily='var(--font-mono)'>
                    <textPath href='#ks-stamp-path' textLength='486' lengthAdjust='spacing'>{STAMP_TEXT}</textPath>
                </text>
            </svg>
            <span className='absolute inset-0 flex items-center justify-center'>
                <span className='flex size-14 items-center justify-center bg-signal text-night md:size-16'>
                    <Check className='size-7 md:size-8' strokeWidth={2.5} />
                </span>
            </span>
        </div>
    </div>
)
